const fkeys = {
  same: 'same',
  different: '',
  contains: '',
  notContains: '',
  major: '',
  minor: ''
}

export const uiConstants = {
  filters: [
    { label: 'region', type: 'text', comparator: [fkeys.contains] },
    { label: 'district', type: 'text' },
    { label: 'city', type: 'text' },
    { label: 'address', type: 'text' },
    { label: 'id', type: 'number' },
    { label: 'date', type: 'date' },
    { label: 'anomalyType', type: 'text' },
    { label: 'note', type: 'text' },
    { label: 'owner', type: 'owner' },
    { label: 'severity', type: 'severity' }
  ],
  filtersComparator: [
    { label: 'uguale a', sql: '= ', key: 'same' },
    { label: 'diverso da', sql: '<>', key: 'different' },
    { label: 'contiene', sql: 'like %%s%', key: 'contains' },
    { label: 'non contiene', sql: 'not like %%s%', key: 'not_contains' },
    { label: 'maggiore di', sql: '>', key: 'major' },
    { label: 'minore di', sql: '<', key: 'minor' }
  ],
  clusterSizes: [10000, 1000, 100, 50, 10],
  menuList: [
    {
      label: 'mappa',
      link: '/dashboard',
      icon: 'fas fa-map-marker-alt'
    },
    {
      label: 'lotti',
      link: '/detections',
      icon: 'fas fa-layer-group'
    },
    {
      label: 'ispezioni',
      link: '/inspections',
      icon: 'fas fa-camera'
    },
    {
      label: 'manutenzioni',
      link: '/restores',
      icon: 'fas fa-hard-hat'
    },
    {
      label: 'assicurazione',
      link: '/insurance',
      icon: 'fas fa-umbrella'
    }
  ],
  toast: {
    success: 'success',
    warning: 'warning',
    error: 'error'
  },
  grant: {
    manageHole: 1
  },
  imageQuality: {
    marker: 0,
    low: 1,
    medium: 2,
    high: 3
  },
  pouchdb_upload_db: 'anomaleet_uploader'
}
